/* ⚠️ Charl, 14 Oct: "for the production team ... fixings and consumables are off, rainwater and fabrication is off, roofing and
   cladding metal profiles is off - in the parameters - but in actual fact they are all on ... the pricing tier also flicks on
   for them ... I'd rather switch it on through the parameters, but just make sure all those parameters actually work."
   The cause: the home screen and the drawing screen asked "is this person role admin?" before looking at the switch, and the
   Workshop (production) logins ARE role admin - so a switch set OFF on their card was overruled on the screen.

   ONE rule, used by the home screen, the drawing screen AND the card on Users (so the card can never say OFF while the
   screen shows it):
   - a Full admin gets everything;
   - a switch that has been SET, on or off, is obeyed;
   - a switch nobody has set keeps what that person had before this change: the office (Orders Admins) keep the pricing
     tier, Fixings, Rainwater, counter sales and custom items; everyone except the floor keeps the Roofing tile; the floor
     (role admin without Orders) gets none of them until switched on. */
export const MAIN_EMAIL = "admin@flashfold.co.nz";
export function isFullAdminU(u, perms) {
  if (!u) return false;
  const p = perms || u.permissions || {};
  return (u.role === "admin" && p.fullAdmin !== false) || p.adminPanel === true || u.email === MAIN_EMAIL;
}
/* the switches this rule governs - the card shows these as what the person actually gets */
/* 16 Oct: canAluStudio - the Aluminium & Fabrication Studio, "its own switch, off by default" (not an office key, so
   nobody gets it until it is switched on; a Full admin always has it). Same rule as access.js aluStudio. */
export const MANAGED_SWITCHES = ["tierToggle", "canProducts", "canRainwater", "canRoofing", "counterSales", "customPricing", "canAluStudio"];
const OFFICE_KEYS = ["tierToggle", "canProducts", "canRainwater", "counterSales", "customPricing"];
export function permOn(u, key, perms) {
  if (!u) return false;
  const p = perms || u.permissions || {};
  if (isFullAdminU(u, p)) return true;
  if (p[key] === true) return true;
  if (p[key] === false) return false;
  const office = u.role === "admin" && p.admin_orders === true;
  if (key === "canRoofing") return !(u.role === "admin" && !office);   // customers and the office as before; the floor off
  if (OFFICE_KEYS.indexOf(key) >= 0) return office;
  return false;
}
